import PropTypes from 'prop-types';
import classnames from 'classnames';
import camelCase from 'lodash/camelCase';
import styles from './ImageBackground.module.scss';
import imageStyles from '../../styles/images.module.scss';

function ImageBackground({ src, className, children, ...props }) {
  return (
    <div
      className={classnames(styles.container, imageStyles[camelCase(src)], className)}
      style={{ backgroundImage: `url('${process.env.PUBLIC_URL}/images/${src}')` }}
      {...props}
    >
      {children}
    </div>
  );
}

ImageBackground.propTypes = {
  src: PropTypes.string.isRequired,
  className: PropTypes.string,
  children: PropTypes.node,
};

export default ImageBackground;
